import { render, staticRenderFns } from "./FarmCreatedLink.vue?vue&type=template&id=6adb030e&scoped=true"
import script from "./FarmCreatedLink.vue?vue&type=script&lang=js"
export * from "./FarmCreatedLink.vue?vue&type=script&lang=js"
import style0 from "./FarmCreatedLink.vue?vue&type=style&index=0&id=6adb030e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb030e",
  null
  
)

export default component.exports